const state = {

    pricingRoomResult:[],
    

};

const getters = {


    GET_PRICING_ROOM_RESULT: (state) => {
        return state.pricingRoomResult;
    },
    
};


const actions = {
    CLEAR_HOTEL_ROOM_RESULT_STORE: ({ commit }) => {
        commit('clearHotelRoomResultStore');
    },
    SET_PRICING_ROOM_RESULT: ({ commit }, result) => {
        commit('savePricingRoomResult', result)
    },
};


const mutations = {
    clearHotelRoomResultStore: (state) => {
        
        state.pricingRoomResult=null;
        

    },
   
    savePricingRoomResult: (state, result) => {
        state.pricingRoomResult = result;
    },
   


};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}